var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9958 17.7036C8.96402 17.7036 4.66602 18.4969 4.66602 21.6703C4.66602 24.8448 8.93718 25.6661 13.9958 25.6661C19.0277 25.6661 23.3257 24.8739 23.3257 21.6994C23.3257 18.5249 19.0557 17.7036 13.9958 17.7036Z",
    fill: "#130F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.9963 14.681C17.4239 14.681 20.1703 11.9335 20.1703 8.50701C20.1703 5.08051 17.4239 2.33301 13.9963 2.33301C10.5698 2.33301 7.82227 5.08051 7.82227 8.50701C7.82227 11.9335 10.5698 14.681 13.9963 14.681Z",
    fill: "#130F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.585cea10f3248de43d81b29f81111435.svg";
export { ForwardRef as ReactComponent };